import Vue from 'vue'
import Vuex from 'vuex'
import { resolveFileUrl, resolveFileThumb } from '@/lib/fileUrl'
import { bindAxios, syncAxiosAuthToken, registerAuthExpiredHandler } from '@/lib/auth'
import App from './App.vue'

Vue.prototype.$resolveFileUrl = resolveFileUrl
Vue.prototype.$resolveFileThumb = resolveFileThumb
import router from './router'
import store from './store'
import { createProvider } from './vue-apollo'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

require('@/assets/css/font-awesome.css')
import '@/assets/css/main.scss'

const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), { moment })

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/es'
import 'vue2-datepicker/index.css'
Vue.component('DatePicker', DatePicker)

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
Vue.component('multiselect', Multiselect)

import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
Vue.component('vue-simple-suggest', VueSimpleSuggest)

import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'
Vue.use(VueToast, { position: 'top-right' })

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)

import VueSignaturePad from 'vue-signature-pad'
Vue.use(VueSignaturePad)

import SimpleVueValidation from 'simple-vue-validator'
Vue.use(SimpleVueValidation, { mode: 'conservative' })

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
  color: '#02bcd7',
  failedColor: 'red',
  height: '2px',
})

import '../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css'
import VueAdsPagination from 'vue-ads-pagination'
Vue.component('VueAdsPagination', VueAdsPagination)

Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'
const API_URL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000'
axios.defaults.baseURL = API_URL
axios.defaults.headers.post['Content-Type'] = 'application/json'
bindAxios(axios)
syncAxiosAuthToken()
Vue.use(VueAxios, axios)

registerAuthExpiredHandler(() => {
  if (router.currentRoute.path === '/logout' || router.currentRoute.path === '/login') {
    return
  }
  router.push('/logout')
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount('#app')
